<template>
  <div
    :class="[
      'wt2-dashboard-discover',
      'wt2-breakpoints',
      {
        'no-transition': !listTransition,
      },
    ]"
  >
    <div class="-panel -two-lines">
      <div>
        <div class="wt2-text-2xl">
          {{ 'dashboardDiscover.title' | culture }}
        </div>
        <div>{{ 'dashboardDiscover.titleExplanation' | culture }}</div>
      </div>
    </div>

    <discover-tab-filtering-bar
      :filters="filters"
      @on-change="onFilterChange"
    />
    <discover-tab-production-line-selector @on-change="onFilterChange" />

    <div class="-content">
      <wt-continuous-pagination class="-scrollable" :on-next-page="onNextPage">
        <div class="wt2-discover-container">
          <template v-if="!isFetchingVideos || videosClone.length">
            <div
              v-if="isEmptyVideos"
              class="wt2-story-previews-empty-state -empty-state-box -ready-made"
            >
              <div class="-centered">
                <img src="/resources/img/empty_no_results.png" />
                <div class="-title">
                  {{ 'dashboardDiscover.empty2title' | culture }}
                </div>
                <div class="-message">
                  {{ 'dashboardDiscover.empty2subtitle' | culture }}
                </div>
              </div>
            </div>
            <template v-else>
              <transition-group
                tag="ul"
                name="wt2-slide-from-top"
                :appear="false"
                :css="listTransition"
                :class="['wt2-story-previews', 'list-inline', '-ready-made']"
              >
                <template v-for="(video, i) in videosClone">
                  <ready-made-preview-item
                    v-if="!video.expanded && !video.dummy"
                    :key="video.id"
                    :story="video"
                    @click.native="selectVideo(i)"
                  />
                  <li v-else-if="video.dummy" :key="video.id" class="-dummy" />
                  <expanded-gallery-item
                    v-else
                    :key="video.id"
                    :left="left"
                    tag="li"
                    @close="selectVideo(-1)"
                    :video="selectedVideo"
                  >
                    <div class="wt2-text-l -title">
                      {{ selectedVideo.title }}
                    </div>
                    <div class="wt2-text-n -info">
                      <ul class="wt2-inline-list">
                        <li>
                          {{ 'storyboards.brand' | culture }}:
                          {{ videoBrandName }}
                        </li>
                        <li>
                          {{
                            selectedVideo.publishedDate
                              | timeFormat('lll', true)
                          }}
                        </li>
                        <li>
                          {{ 'instantVideos.category' | culture }}:
                          {{ selectedVideo.topicDisplayText }}
                        </li>
                        <li>
                          {{ 'instantVideos.length' | culture }}
                          {{
                            (selectedVideo.videoDuration * 1e3)
                              | timeFormatDuration('mm:ss')
                          }}
                        </li>
                      </ul>
                    </div>
                    <div class="wt2-text-n -description">
                      {{ selectedVideo.description }}
                    </div>
                    <div class="wt2-text-n -id">ID: {{ selectedVideo.id }}</div>
                    <div class="wt2-text-n -links">
                      <ul class="wt2-inline-list">
                        <li>
                          <a href="#" @click.prevent="copyLink">
                            <i class="wticon wticon-link2" />
                            <span v-if="isCopied" class="wt2-color-disabled"
                              >Link copied</span
                            >
                            <span v-else>{{
                              'instantVideos.copyLink' | culture
                            }}</span>
                          </a>
                        </li>
                        <li v-if="originalStoryUrl">
                          <a :href="mixinSrc(originalStoryUrl)" target="_blank">
                            <i class="wticon wticon-world" />
                            {{ 'instantVideos.originalArticle' | culture }}
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            @click.prevent="
                              openSlack(selectedVideo, 'ready_to_publish')
                            "
                          >
                            <i class="wticon wticon-slack-small-icon" />
                            {{ 'instantVideos.shareOnSlack' | culture }}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <input type="text" readOnly ref="input" :value="videoUrl" />
                    <div class="-actions">
                      <wt-button
                        :text="'generic.EDIT' | culture"
                        type="secondary"
                        @click="openMakeCopy"
                      />
                      <wt-button
                        :text="'instantVideos.produce' | culture"
                        @click="openRebrand"
                      />
                    </div>
                  </expanded-gallery-item>
                </template>
              </transition-group>
            </template>
          </template>
        </div>
      </wt-continuous-pagination>
      <div class="wt-dashboard-loader" v-show="isFetchingVideos">
        <div class="wt-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import ReadyMadePreviewItem from 'v/Dashboard/ReadyMadePreviewItem.vue';
import DiscoverTabFilteringBar from 'v/Dashboard/DiscoverTabFilteringBar.vue';
import DiscoverTabProductionLineSelector from 'v/Dashboard/DiscoverTabProductionLineSelector.vue';
import ExpandedGalleryItem from 'v/Dashboard/ExpandedGalleryItem.vue';
import { DuplicateController } from 'c/DuplicateController';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'dashboard-discover',

  components: {
    ReadyMadePreviewItem,
    DiscoverTabFilteringBar,
    DiscoverTabProductionLineSelector,
    ExpandedGalleryItem,
  },

  data() {
    return {
      indexOfselectedVideo: -1,
      listTransition: true,
      isCopied: false,
    };
  },

  created() {
    this.filters.q = '';
    this.$store.state.dashboard.readyMadeVideos = [];

    this.$store.dispatch('fetchReadyMadeProgrammers').then(() => {
      this.refreshCurrentList({ bReset: true, bFetchMore: false });
    });
  },

  mounted() {
    this.$nextTick(() => {
      this.calcItemDimensions();
    });
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    filters: {
      handler() {
        this.disableTransitions();
      },
      deep: true,
    },
    selectedOrganizationId() {
      this.refreshCurrentList({ bReset: false });
    },

    isFetchingVideos(newVal) {
      if (newVal) {
        this.selectVideo(-1);
      } else {
        this.calcItemDimensions();
      }
    },
  },

  computed: {
    ...mapGetters(['readyMadeVideos']),
    ...mapState('user', ['organizations']),
    ...mapState({
      selectedOrganizationId: (state) => state.user.selectedOrganizationId,
      filters: (state) => state.dashboard.readyMadeVideosFilters,
      galleryItem: (state) => state.dashboard.galleryItem,
      videos: (state) => state.dashboard.readyMadeVideos,
    }),

    videoBrandName() {
      let rv = this.selectedVideo.programmerName;

      for (const org of this.organizations) {
        const brand = org.brands.find(
          (brand) =>
            brand.brandId === this.selectedVideo.brandId &&
            brand.programmerId === this.selectedVideo.programmerId
        );
        if (brand) {
          rv = brand.name;
          break;
        }
      }

      return rv;
    },

    videoUrl() {
      return app.generatePublishUrl(this.selectedVideo.id);
    },

    originalStoryUrl() {
      if (this.selectedVideo) {
        const storyUrls = _.compact(this.selectedVideo.storyUrls);
        if (storyUrls.length) {
          return storyUrls[0];
        }
      }
      return null;
    },

    isFetchingVideos() {
      return this.$store.getters.fetching.readyMadeVideos;
    },

    isEmptyVideos() {
      return (
        this.$store.state.dashboard.hasEmpty.readyMadeVideos &&
        !this.isFetchingVideos
      );
    },

    showProgrammerDropdown() {
      return app.programmers.length > 1;
    },

    left() {
      // TODO: remove hard coded values
      return (
        Math.round(this.galleryItem.width) * this.indexOfReadyMadeVideoInRow +
        this.galleryItem.width / 2 +
        20
      );
    },

    selectedVideo() {
      if (this.indexOfselectedVideo >= 0) {
        return Object.assign(
          {},
          this.readyMadeVideos[this.indexOfselectedVideo]
        );
      }
    },

    videosClone() {
      let arr = [];
      let i = 0;
      if (this.indexOfExpandedItemInList < 0) {
        arr = this.readyMadeVideos.concat();
      } else {
        while (i < this.indexOfExpandedItemInList) {
          if (this.readyMadeVideos[i]) {
            arr.push(this.readyMadeVideos[i]);
          } else {
            arr.push({ expanded: false, dummy: true, id: this.lineNumber });
          }
          i++;
        }
        arr.push({ expanded: true, id: this.lineNumber });
        while (i < this.readyMadeVideos.length) {
          arr.push(this.readyMadeVideos[i]);
          i++;
        }
      }
      return arr;
    },

    lineNumber() {
      if (this.indexOfselectedVideo < 0) {
        return -1;
      } else {
        return Math.floor(
          this.indexOfselectedVideo / this.galleryItem.numberInRow
        );
      }
    },

    indexOfExpandedItemInList() {
      if (this.indexOfselectedVideo < 0) {
        return -1;
      } else {
        return (this.lineNumber + 1) * this.galleryItem.numberInRow;
      }
    },

    indexOfReadyMadeVideoInRow() {
      if (this.indexOfselectedVideo < 0) {
        return -1;
      } else {
        return this.indexOfselectedVideo % this.galleryItem.numberInRow;
      }
    },
  },

  methods: {
    ...mapMutations(['requestPause', 'setGalleryItemDetails']),

    refreshCurrentList(options) {
      return this.$store.dispatch('fetchReadyMadeVideos', options);
    },

    disableTransitions() {
      this.listTransition = false;
      setTimeout(() => {
        this.listTransition = true;
      }, 1000);
    },

    onFilterChange() {
      this.disableTransitions();
      this.indexOfselectedVideo = -1;
      this.refreshCurrentList({ bReset: true, bFetchMore: false });
    },

    onNextPage() {
      this.$store.dispatch('fetchReadyMadeVideos', {
        bReset: false,
        bFetchMore: true,
      });
    },

    selectVideo(index) {
      const indexOfExpandedItem = _.findIndex(
        this.videosClone,
        (v) => _.isObject(v) && v.expanded
      );
      const newIndex =
        indexOfExpandedItem >= 0 && index > indexOfExpandedItem
          ? index - 1
          : index;
      if (this.indexOfselectedVideo === newIndex) {
        this.indexOfselectedVideo = -1;
      } else {
        this.indexOfselectedVideo = newIndex;
      }

      if (this.selectedVideo) {
        app.analytics('discover:preview', {
          videoID: this.selectedVideo.id,
        });
      }
    },

    onResize: _.debounce(
      function () {
        const fullscreenElement =
          document.fullscreenElement || document.webkitFullscreenElement;

        if (!fullscreenElement) {
          this.calcItemDimensions();
        }
      },
      10,
      { leading: true }
    ),

    calcItemDimensions() {
      const ul = this.$el.querySelector('.-ready-made');
      if (!ul) {
        return;
      }
      const cs = window.getComputedStyle(ul);
      const numberInRow = +cs.getPropertyValue('--thumbnails-in-row');
      const padding = parseInt(cs.paddingLeft) + parseInt(cs.paddingRight);
      const width = ul.parentElement.getBoundingClientRect().width - padding;
      const itemWidth = width / numberInRow;
      const itemHeight = ((itemWidth - 16) * 9) / 16 + 30; // TODO remove hardCoded value
      this.setGalleryItemDetails({
        numberInRow,
        padding,
        width: itemWidth,
        height: itemHeight,
      });
    },

    openRebrand() {
      this.requestPause();
      this.mixinShowViewInModal({
        type: 'small',
        component: 'wt-rebrand',
        componentPropsData: {
          story: this.selectedVideo,
          source: 'Discover Dashboard',
        },
      });
    },

    openMakeCopy() {
      this.requestPause();

      DuplicateController.openDialog({
        story: this.selectedVideo,
        useStoryOriginalBrandId: false,
        showOrganizationList: false,
        title: app.culture.makeCopyDialog.titleVideo,
        message: app.culture.makeCopyDialog.messageReadyMade,
        buttonText: app.culture.makeCopyDialog.buttonTextReadyMade,
        storyStartPoint: app.storyStartPoint.INSTANT,
      }).then((data) => {
        app.analytics('discover:clone', {
          videoID: this.selectedVideo.id,
        });

        if (data.changeOrg) {
          app.delayedSpinner.hide();
          app.dialog.confirm({
            type: app.dialog.types.CONFIRM_1,
            title: 'Copied',
            description: `
<div><p>Video is duplicated successfully!
You can access it on your dashboard drafts.
Remember to change the view to the relevant account.</p></div>`,
            showContactCsm: false,
            buttonYesText: 'Close',
            buttonYesAction: true,
          });
        } else {
          app.navigate('stories/' + data.storyId);
        }
      });
    },

    copyLink() {
      const input = _.isArray(this.$refs.input) ? this.$refs.input[0] : null;

      if (input && input.select && !this.isCopied) {
        input.select();
        input.blur();

        try {
          // copy text
          document.execCommand('copy');
          this.isCopied = true;

          _.delay(() => {
            this.isCopied = false;
          }, app.TIME.SECOND * 3);
        } catch (err) {
          console.warn(
            `fullPreview::copyLink->fail err: ${JSON.stringify(err)}`
          );
        }
      }
    },

    openSlack(video, videoType) {
      this.requestPause();
      this.mixinShowViewInModal({
        type: 'small',
        component: 'wt-slack',
        componentPropsData: {
          video: video,
          videoType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wt2-dashboard-discover {
  background-image: url('https://dp4stoslb9jdl.cloudfront.net/Resources/studio/img/pattern-white.png');

  .wt2-discover-filtering {
    display: flex;
    justify-content: center;
  }
}
</style>
